import React, { ReactNode } from "react";
import { PageLoadingIcon } from "../Icons";
import * as S from "./PageLoading.styles";

export interface PageLoadingProps {
  /** Show only the loading icon without text */
  iconOnly?: boolean;
  /** Additional content to append to the loading message */
  loadType?: string;
  /** Loading message text (defaults to "Loading") */
  loadingText?: ReactNode;
}

export const PageLoading = ({
  iconOnly = false,
  loadType,
  loadingText = "Loading"
}: PageLoadingProps) => (
  <S.LoadingWrapper iconOnly={iconOnly}>
    <PageLoadingIcon />
    {!iconOnly && (
      <S.MessageWrapper>
        {loadingText}
        {loadType ? " " + loadType : ""}...
      </S.MessageWrapper>
    )}
  </S.LoadingWrapper>
);
